(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["note-feed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('note-feed-831')) {
  customElements.define('note-feed-831', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const endpoint = this.dataset.endpoint;
      if (!endpoint) return;
      this.refresh(endpoint);
    }
    async refresh(endpoint) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(endpoint, { signal: controller.signal, credentials: 'omit' });
        if (!response.ok) throw new Error('Feed unavailable');
        const data = await response.json();
        if (!Array.isArray(data.items) || !data.items.length) throw new Error('Empty feed');
        const items = data.items.slice(0, 3);
        const fragment = document.createDocumentFragment();
        for (const item of items) {
          const url = new URL(item.link);
          if (url.origin !== 'https://note.com' || !/^\/funcreate8\/n\/[a-z0-9]+$/.test(url.pathname) || typeof item.title !== 'string' || !item.title.trim()) throw new Error('Invalid article');
          const date = new Date(item.pubDate);
          if (!Number.isFinite(date.getTime())) throw new Error('Invalid date');
          const card = document.createElement('a');
          card.href = url.href; card.className = 'note-card'; card.target = '_blank'; card.rel = 'noopener noreferrer';
          if (item.thumbnail) {
            const imageUrl = new URL(item.thumbnail);
            if (imageUrl.protocol === 'https:' && imageUrl.hostname === 'assets.st-note.com') {
              const image = document.createElement('img');
              image.src = imageUrl.href; image.alt = ''; image.className = 'note-card-img'; image.width = 700; image.height = 360; image.loading = 'lazy'; card.append(image);
            }
          }
          const content = document.createElement('div'); content.className = 'note-card-content';
          const title = document.createElement('h3'); title.className = 'note-card-title'; title.textContent = item.title;
          const published = document.createElement('p'); published.className = 'note-card-date';
          published.textContent = new Intl.DateTimeFormat('ja-JP', {timeZone:'Asia/Tokyo',year:'numeric',month:'numeric',day:'numeric'}).format(date);
          content.append(title, published); card.append(content); fragment.append(card);
        }
        this.querySelector('.note-feed-container').replaceChildren(fragment);
      } catch {
        this.dataset.feedStatus = 'fallback';
      } finally {
        clearTimeout(timer);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
